<!-- Tab 3 - Partners -->
<div class="show fade partner_content" id="partnersTab">
  <div class="d-flex flex-column h-100" id="partnersTabFlex">
    <!-- Data heading and info -->
    <div class="data_header" id="partnersTabDataHeader">
        <div class="results_info" id="resultsInfo">
          <div class="title" id="title"><span i18n="@@partners.header.partners">Partners</span></div>
          <div class="results" id="resultsPC" *ngIf="displayPartnerData?.length > 0">
            <span i18n="@@partners.results.showing-of-partners">Showing <strong>{{ showFrom }} - {{ showTo }}</strong>
              of
              <strong>{{ displayPartnerData?.length }} Partners</strong></span>
          </div>
        </div>
        <div class="left_side_section" id="partnerConSideSec">
        <div class="search_group" *ngIf="showSearchDetails || displayPartnerData?.length > 0" id="searchGrp">
          <div class="input-group" id="inputGrp">
            <input #searchValue [(ngModel)]="searchData" (keyup.enter)="getAllPartnersBySearch()" type="text" value=""
              class="form-control" placeholder="{{searchNamePlaceHolderText}}" />
            <img alt="close" *ngIf="searchData?.length" (click)="clearSearch()" class="search-clear-icon">
          </div>
          <button type="button" (click)="getAllPartnersBySearch()" class="btn btn-primary search_btn gtmPartnerSearch">
            <img class="searchicon" alt="search" />
          </button>
        </div>
      </div>
      <div class="action_buttons">
        <button type="button" class="btn btn-outline-primary" (click)="openMessagePopup()"><span>{{ publishMessageToPartners }}</span></button>
        <div *ngIf="displayPartnerData?.length">
          <button type="button" class="btn btn-primary btn-lg left_icon_btn gtmNewPartner" data-toggle="modal"
            data-target="#addPartnerPopup" (click)="openCreateModal()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12 5.25C12.1989 5.25 12.3897 5.32902 12.5303 5.46967C12.671 5.61032 12.75 5.80109 12.75 6V12C12.75 12.1989 12.671 12.3897 12.5303 12.5303C12.3897 12.671 12.1989 12.75 12 12.75H6C5.80109 12.75 5.61032 12.671 5.46967 12.5303C5.32902 12.3897 5.25 12.1989 5.25 12C5.25 11.8011 5.32902 11.6103 5.46967 11.4697C5.61032 11.329 5.80109 11.25 6 11.25H11.25V6C11.25 5.80109 11.329 5.61032 11.4697 5.46967C11.6103 5.32902 11.8011 5.25 12 5.25Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M11.25 12C11.25 11.8011 11.329 11.6103 11.4697 11.4697C11.6103 11.329 11.8011 11.25 12 11.25H18C18.1989 11.25 18.3897 11.329 18.5303 11.4697C18.671 11.6103 18.75 11.8011 18.75 12C18.75 12.1989 18.671 12.3897 18.5303 12.5303C18.3897 12.671 18.1989 12.75 18 12.75H12.75V18C12.75 18.1989 12.671 18.3897 12.5303 18.5303C12.3897 18.671 12.1989 18.75 12 18.75C11.8011 18.75 11.6103 18.671 11.4697 18.5303C11.329 18.3897 11.25 18.1989 11.25 18V12Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M21 1.5H3C2.60218 1.5 2.22064 1.65804 1.93934 1.93934C1.65804 2.22064 1.5 2.60218 1.5 3V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H21C21.3978 22.5 21.7794 22.342 22.0607 22.0607C22.342 21.7794 22.5 21.3978 22.5 21V3C22.5 2.60218 22.342 2.22064 22.0607 1.93934C21.7794 1.65804 21.3978 1.5 21 1.5ZM3 0C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3L0 21C0 21.7956 0.316071 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H21C21.7956 24 22.5587 23.6839 23.1213 23.1213C23.6839 22.5587 24 21.7956 24 21V3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.316071 21.7956 0 21 0L3 0Z" />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span i18n="@@partners.new-partner.new-partner">New Partner</span>
          </button>
        </div>
      </div>
    </div>
    <hr />
    <div class="text-center" *ngIf="dataSearch" id="dataSearchFound">
      <span>No Records Found</span>
    </div>
    <!-- Table data -->
    <div id="tblResMainDiv">
      <div class="table-responsive" id="partnerDataTblRes">
        <table id="partnersTable" class="table table-borderless" aria-describedby="partners">
          <thead *ngIf="!dataSearch">
            <tr [ngClass]="!isPartnerDataEmpty ? 'existing_partner_show': 'existing_partner_hide'">
              <th #partnerName scope="col" data-order="asc" data-name="partnerName">
                <span class="table_headings">
                  <span i18n="@@partners.partner-name.partner-name">Partner Name</span>
                  <span class="chevron_expand" (click)="getPartnerSoryByName('partnerName',partnerNameSort)"></span>
                </span>
              </th>
              <th #createdTime scope="col" data-order="asc" data-name="createdTime">
                <span class="table_headings">
                  <span i18n="@@partners.created.created-on">Created On</span>
                  <span class="chevron_expand" (click)="getPartnerSoryByTime('createdTime',partnerCreatedTime)"></span>
                </span>
              </th>
              <th #updatedTime scope="col" data-order="asc" data-name="updatedTime">
                <span class="table_headings">
                  <span i18n="@@partners.last-updated.last-updated">Last Updated</span>
                  <span class="chevron_expand"
                    (click)="getPartnerSoryByUpdatedTime('updatedTime',partnerUpdatedTime)"></span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let partner of displayPartnerData | slice: (page-1) * tableSize : page * tableSize">
              <tr>
                <td>{{partner.partnerName}}</td>
                <td>{{partner.createdTime | dateFormat: 'changeToLocalTimeZone'}}</td>
                <td>{{partner.updatedTime | dateFormat: 'changeToLocalTimeZone'}}</td>
                <td>
                  <!-- The following span should be displayed when accordion is open   -->
                  <span class="finalize_editing">
                    <button *ngIf="partner.isEdit" class="btn btn-outline-primary btn-sm"
                      (click)="cancelEdit(partner?.partnerId)">
                      <span i18n="@@partners.cancel.cancel">Cancel</span>
                    </button>
                    <button [disabled]="showTypeError || showSizeError || !partner.partnerName" *ngIf="partner.isEdit"
                      class="btn btn-primary btn-sm"
                      (click)="updatePartner(partner.partnerId, partner.partnerName, partner.isChromeEnabled)">
                      <span i18n="@@partners.save-changes.save-changes">Save Changes</span>
                    </button>
                  </span>
                </td>
                <td class="action_cell">
                  <div class="modify_record" id="modifyRecord">
                    <span>
                      <!-- The following button should be displayed when accordion is collapsed   -->
                      <span *ngIf="!partner.isEdit" class="collapsed edit_record" data-toggle="collapse"
                        data-target="#partnersRow1">
                        <img data-toggle="tooltip" data-placement="top" [ngbTooltip]="editTooltip" class="edit_icon"
                          alt="edit" (click)="editPartnerDetails(partner?.partnerId)" />
                      </span>

                    </span>

                    <!-- Expand arrow -->
                    <span class="table_collapse_link collapsed" data-toggle="collapse"
                      [attr.data-target]="'#' + partner.partnerId" [attr.aria-expanded]="partner.isExpanded"
                      aria-controls="collapseOne">
                      <img class="table_row_expanded" alt="expand" [ngClass]="partner.isExpanded?'transform-180':''"
                        (click)="getDetailsOfPartners(partner?.partnerId)" />
                    </span>
                  </div>
                </td>
              </tr>
              <!-- Row 1 - Expanded data -->
              <tr class="collapse" id="collapseOne" data-parent="#partnersTable" #collapse="ngbCollapse"
                aria-labelledby="partnerCollapse" [(ngbCollapse)]="!partner.isExpanded">
                <td colspan="100%">
                  <div class="data_title" id="dataTitleDes"><span i18n="@@partners.details.details">Details</span></div>
                  <div class="d-flex" id="partnerNameDFlex">
                    <div class="editable_data" id="editableData">
                      <div class="form-group" id="frmGrpPartner">
                        <label for=""><span i18n="@@partners.partner-name.partner-name">Partner Name</span></label>
                        <div *ngIf="!partner.isEdit" id="isEditPartnerNam">{{ partner?.partnerName }}</div>
                        <div *ngIf="partner.isEdit" id="partnerMaxLength"><input class="form-control" maxLength="50"
                            [(ngModel)]="partner.partnerName" type="text" value="Ezon Electronics" />
                        </div>
                        <div *ngIf="duplicatePartner && partner.isEdit" id="partnerNameExist" class="text-danger"><span
                            i18n="@@partners.partner-name-validation.partner-name-already-exits.">Partner Name already
                            exists.</span></div>
                      </div>
                      <div class="form-group" id="partnerCreatedOn">
                        <label for=""><span i18n="@@partners.created.created-on">Created On</span></label>
                        <div>{{partner.createdTime | dateFormat: 'shortDateFormat'}}</div>
                      </div>
                      <div class="form-group" id="partnerLastUpdated">
                        <label for=""><span i18n="@@partners.last-updated.last-updated">Last Updated</span></label>
                        <div>{{partner.updatedTime | dateFormat: 'shortDateFormat'}}</div>
                      </div>
                      <div class="form-group" id="oemBtnDiv">
                        <button id="oemButton" class="btn border border-dark btn-lg" *ngIf="partner.isChromeEnabled == 'Yes' && !partner.isEdit"><span>{{ oemCheckPartnerCreation }}</span></button>
                        <div *ngIf="partner.isEdit" id="oemChkPartnerCreation"><input id="oemCheckBox" type="checkbox" (change)="oemChange($event,partner.partnerId)" [checked] = "partner.isChromeEnabled === 'Yes'"/>
                          <label id="font-oem"><span>{{ oemCheckPartnerCreation }}</span></label>
                        </div>
                      </div>
                    </div>
                    <div class="editable_data" id="editableData">
                      <div class="form-group" id="partnerLogoFrmGrp">
                        <label for=""><span i18n="@@partners.partner-logo.partner-logo">Partner Logo</span></label>
                        <div *ngIf="!editImageFlag" id="partner.Config">{{partner.editImageName}}</div>
                        <div *ngIf="editImageFlag && !showTypeError && !showSizeError" id="partnerFileName">{{fileName}}</div>
                        <div *ngIf="showSizeError && !showTypeError" class="uploadfile_err_msg" id="fileExceedMaxSize">
                          <span i18n="@@partners.partner-file-logo.file-exceeds-maximum-size">File exceeds maximum size
                            <strong>(5 MB).</strong></span>
                        </div>
                        <div *ngIf="showTypeError" class="uploadfile_err_msg error-msg-width" id="uploadFileErrMsg">
                          <span [innerHTML]="partnerLogoMsg2"></span></div>
                        <div class="partner_logo" *ngIf="partner.editImageName && !showTypeError && !showSizeError " id="partnerLogo">
                          <img [src]="partner?.imageUrl" alt="logo" />

                        </div>
                        <button *ngIf="partner.isEdit" class="btn btn-primary btn-sm left_icon_btn"
                          (click)="fileInputLogo.click()">
                          <img class="image_icon" alt="upload logo" />
                          <span i18n="@@partners.upload-logo-upload-logo">Upload Logo</span>
                          <input #fileInputLogo type="file" accept="image/jpg,image/x-png,image/jpeg"
                            (change)="imagePreview(fileInputLogo, partner.partnerId)" style="display:none;" />
                        </button>
                      </div>
                    </div>
                    <div class="editable_data" id="editableData">
                      <div class="form-group" id="partnerLogoFrmGrp">
                        <label for="" *ngIf="(partner?.videoUrl && partner?.videoUrl !=='') || partner.isEdit"><span>{{partnerVideosText}}</span></label>
                        <div *ngIf="!videoEditFlag" id="partner.Config">{{partner.editVideoName}}</div>
                        <div *ngIf="videoEditFlag && !editFileTypeError && !editVideoSizeError && !videoLengthError" id="partnerFileName">{{editVideoFileName}}</div>
                        <div *ngIf="editFileTypeError" class="uploadfile_err_msg" id="fileExceedMaxSize">
                          <span i18n="@@create-attractor-loop-oem.videoTypeError.incorrect">Incorrect file type received.</span>
                          <div id="fileTypeErrorText"><span i18n="@@global.tooltip.video-rule-format">Video must be in <strong>MP4</strong> format.</span></div>
                        </div>
                        <div *ngIf="editVideoSizeError" class="uploadfile_err_msg error-msg-width" id="uploadFileErrMsg">
                          <span i18n="@@global.content-grp.video-size-error">Video exceeds maximum size of <strong>10 MB.</strong></span>
                        </div>
                        <div *ngIf="videoLengthError" class="uploadfile_err_msg error-msg-width" id="uploadFileErrMsg">
                          <span i18n="@@global.content-grp.video-duration-error">Video must be <strong>less than 60 seconds long.</strong></span>
                        </div>
                        <div class="partner_video" id="partnervideo">
                          <video [src]="partner?.videoUrl" *ngIf="partner?.videoUrl" controls></video>
                        </div>
                        <button *ngIf="partner.isEdit" class="btn btn-primary btn-sm left_icon_btn"
                          (click)="fileInputVideo.click()">
                          <img class="video_icon" alt="upload video" />
                          <span i18n="@@create-attractor-loop.images.upload">Upload Video</span>
                          <input #fileInputVideo type="file" accept="video/mp4"
                            (change)="videoPreview(fileInputVideo, partner.partnerId)" style="display:none;" />
                        </button>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
            <tr class="remove_border" [ngClass]="isPartnerDataEmpty ? 'existing_partner_show': 'existing_partner_hide'">
              <div class="allign_text" id="noPartnerYet"><span i18n="@@partners.no-partners-there-are-no-partners-yet">There are no
                  Partners yet.</span></div>
              <td class="profile_Record">
                <div class="action_buttons" id="gtmNewPartner">
                  <button type="button" class="btn btn-primary btn-lg left_icon_btn gtmNewPartner" data-toggle="modal"
                    data-target="#addPartnerPopup" (click)="openCreateModal()">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0)">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M12 5.25C12.1989 5.25 12.3897 5.32902 12.5303 5.46967C12.671 5.61032 12.75 5.80109 12.75 6V12C12.75 12.1989 12.671 12.3897 12.5303 12.5303C12.3897 12.671 12.1989 12.75 12 12.75H6C5.80109 12.75 5.61032 12.671 5.46967 12.5303C5.32902 12.3897 5.25 12.1989 5.25 12C5.25 11.8011 5.32902 11.6103 5.46967 11.4697C5.61032 11.329 5.80109 11.25 6 11.25H11.25V6C11.25 5.80109 11.329 5.61032 11.4697 5.46967C11.6103 5.32902 11.8011 5.25 12 5.25Z" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M11.25 12C11.25 11.8011 11.329 11.6103 11.4697 11.4697C11.6103 11.329 11.8011 11.25 12 11.25H18C18.1989 11.25 18.3897 11.329 18.5303 11.4697C18.671 11.6103 18.75 11.8011 18.75 12C18.75 12.1989 18.671 12.3897 18.5303 12.5303C18.3897 12.671 18.1989 12.75 18 12.75H12.75V18C12.75 18.1989 12.671 18.3897 12.5303 18.5303C12.3897 18.671 12.1989 18.75 12 18.75C11.8011 18.75 11.6103 18.671 11.4697 18.5303C11.329 18.3897 11.25 18.1989 11.25 18V12Z" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M21 1.5H3C2.60218 1.5 2.22064 1.65804 1.93934 1.93934C1.65804 2.22064 1.5 2.60218 1.5 3V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H21C21.3978 22.5 21.7794 22.342 22.0607 22.0607C22.342 21.7794 22.5 21.3978 22.5 21V3C22.5 2.60218 22.342 2.22064 22.0607 1.93934C21.7794 1.65804 21.3978 1.5 21 1.5ZM3 0C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3L0 21C0 21.7956 0.316071 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H21C21.7956 24 22.5587 23.6839 23.1213 23.1213C23.6839 22.5587 24 21.7956 24 21V3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.316071 21.7956 0 21 0L3 0Z" />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span i18n="@@partners.new-partner.new-partner">New Partner</span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <hr />

    <!-- Pagination -->
    <div class="data_footer position-relative" *ngIf="displayPartnerData?.length" id="dataFooterPartner">
      <div class="d-flex flex-column align-items-center" id="alignItemCenter">
        <nav aria-label="partners pagination">
          <ngb-pagination [collectionSize]="displayPartnerData?.length" [(page)]="page" [pageSize]="tableSize"
            [rotate]="false" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false"
            (pageChange)="onTableDataChange($event)">
          </ngb-pagination>
        </nav>
        <div class="results mt-2" *ngIf="displayPartnerData?.length > 0" id="showingFrm">
          <span i18n="@@partners.results.showing-of-partners">Showing <strong>{{ showFrom }} - {{ showTo }}</strong> of
            <strong>{{ displayPartnerData?.length }} Partners</strong></span>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Add New Partner Popup -->
<div class="container" id="addNewPartnerCon">
  <div class="modal-dialog modal-dialog-centered" *ngIf="openModal" id="modalDialogPartner">
    <div class="modal-backdrop show" id="modalBackDropPartner"></div>
    <div class="modal" id="myModal">
      <div class="modal-dialog" id="myModalDialog">
        <div class="modal-content" id="myModalContent">
          <div class="close" data-dismiss="modal" (click)="closeModal()" id="myModalClose">
            <img class="modal-close-icon" alt="close" />
          </div>
          <div class="modal-body" id="myModalBody">
            <div class="heading" id="myModalHeading"><span i18n="@@partners.new-partner.new-partner">New Partner</span></div>
            <form [formGroup]="partnerForm">
              <div class="form-group" id="partnerName">
                <label for=""><span i18n="@@partners.partner-name.partner-name">Partner Name </span><span
                    class="coral">*</span></label>
                <input type="text" formControlName="partnerName" class="form-control" maxlength="50"
                  placeholder="{{partnerNamePlaceholder}}" />
                <div *ngIf="duplicatePartner" class="text-danger" id="partnerNameValidation"><span
                    i18n="@@partners.partner-name-validation.partner-name-already-exits.">Partner Name already
                    exists.</span></div>
              </div>
              <div class="form-group" id="frmGrpImg">
                <div class="mt-3 mb-3 d-flex" id="assetsUplaodId">
                  <ng-container>
                    <div class="first-tab-container" id="tabContainer"></div>
                    <div class='tab' (click)='tabChange()' [ngClass]="{'active-tab':isUploadLogoTabActive ,'inactive-tab':!isUploadLogoTabActive}">
                      <span id="partnerLogoContent" i18n="@@logo-content.store-logos.upload-button">Upload Logo</span>
                    </div>
                    <div class='tab' (click)='tabChange()' [ngClass]="{'active-tab':!isUploadLogoTabActive ,'inactive-tab':isUploadLogoTabActive}">
                      <span id="partnerVideoContent" i18n="@@create-attractor-loop.images.upload">Upload Video</span>
                    </div>
                  </ng-container>
                  <div class="last-tab-container" id="tabContainer"></div>
                </div>
                <div [hidden]="!isUploadLogoTabActive">
                  <label>
                    <span i18n="@@partners.partner-logo.partner-logo">Partner Logo</span>&nbsp;<span
                      class="coral">*</span>
                    <ng-template #popContent>
                      <div class="popover-upload-req" id="popoverUploadReq">
                        <div class="d-flex align-items-center" id="imgIconPng">
                          <img src="assets/images/image-icon.png" alt="image" />
                          <ul>
                            <li [innerHTML]="partnerLogoMsg1"></li>
                            <li><span i18n="@@partners.partner-image-allowed-allowed-maximum-size-is">Allowed maximum size
                                is <strong>5 MB</strong></span></li>
                          </ul>
                        </div>
                      </div>
                    </ng-template>
                    <img class="round-info-icon" placement="right" [ngbPopover]="popContent"
                      triggers="mouseenter:mouseleave" alt="upload specs" />

                  </label>
                  <button class="btn btn-primary btn-sm left_icon_btn" (click)="fileInput.click()">
                    <span>
                      <img class="image_icon" alt="upload logo" />
                      <span i18n="@@partners.partner-upload-image.upload-image">Upload Image</span>
                    </span>
                    <input #fileInput type="file" formControlName="configurations"
                      accept="image/jpg,image/x-png,image/jpeg" (change)="uploadImageForCreatePartner(fileInput)"
                      hidden />
                  </button>
                  <!-- Use the below span to display uploaded file name -->
                  <div *ngIf="showTypeError" class="uploadfile_err_msg error-msg-width" id="uploadImgFileErrMsg">
                    <span [innerHTML]="partnerLogoMsg2"></span></div>
                  <div *ngIf="showSizeError && !showTypeError" class="uploadfile_err_msg" id="fileExceedsMaxSize">
                    <span i18n="@@partners.partner-file-logo.file-exceeds-maximum-size">File exceeds maximum size
                      <strong>(5 MB).</strong></span>
                  </div>
                  <span *ngIf="!showTypeError && !showSizeError">{{imageName}}</span>
                </div>
                <div [hidden]="isUploadLogoTabActive">
                  <label><span>{{partnerVideosText}}</span>
                  <img class="info_icon" src="assets/images/info_circle_icon.svg" alt="hover for help" placement="right"
                    [ngbPopover]="popContent1" container="body" triggers="mouseenter:mouseleave" />
                  </label>
                  <ng-template #popContent1>
                    <div id="popOver" class="popover-upload-req">
                    <div id="popOverContent" class="d-flex align-items-center">
                      <img src="assets/images/video-icon.png" alt="video"/>
                      <ul >
                        <li i18n="@@global.tooltip.video-rule-format">Video must be in <strong>MP4</strong> format</li>
                        <li i18n="@@global.tooltip.video-rule-length">Allowed maximum length is <strong>60 seconds</strong></li>
                        <li i18n="@@global.tooltip.video-max-size-error">Allowed maximum size is <strong>10 MB</strong></li>
                      </ul>
                    </div>
                  </div>
                  </ng-template>
                  <div id="uploadButton">
                    <div id="videoInput" for="uploadedVideoName">
                      <input accept="video/mp4" #videoInput class="form-control" (change)='onVideoUpload($event)'
                        type="file" hidden />
                      <button (click)='videoInput.click()'
                        class="btn btn-primary left_icon_btn">
                        <span class="upload-video_icon"></span>
                        <span i18n="@@create-attractor-loop.images.upload">Upload Video</span>
                      </button>
                    </div>
                    <div id="videoFileName" *ngIf='isVideoTriggered' class="file-name-container mt-1">
                      {{ isVideo ? videoFile.name: '' }}
                    </div>                    
                    <div id="fileTypeError" *ngIf='fileTypeError' class="uploadfile_err_msg">
                      <span i18n="@@create-attractor-loop-oem.videoTypeError.incorrect">Incorrect file type received.</span>
                      <div id="fileTypeErrorText">
                        <span i18n="@@global.tooltip.video-rule-format">Video must be in <strong>MP4</strong> format.</span>
                      </div>
                    </div>
                    <div id="videoLengthError" *ngIf='videoLengthError' class="uploadfile_err_msg">
                      <span i18n="@@global.content-grp.video-duration-error">Video must be <strong>less than 60 seconds long.</strong></span>
                    </div>
                    <div id="videoSizeError" *ngIf='videoSizeError' class="uploadfile_err_msg">
                      <span i18n="@@global.content-grp.video-size-error">Video exceeds maximum size of <strong>10 MB.</strong></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group" id="oemCheckPartnerCreation">
                <input id="oemCheckBox" type="checkbox" formControlName="isChromeEnabled" />
                <label><span>{{ oemCheckPartnerCreation }}</span></label>
              </div>
            </form>
          </div>
          <div class="modal-footer" id="modalFooterBtns">
            <button type="button" class="btn btn-outline-primary btn-lg" data-dismiss="modal" (click)="closeModal()">
              <span i18n="@@partners.cancel.cancel">Cancel</span>
            </button>
            <button type="button" class="btn btn-primary gtmCreateNewPartner"
              [disabled]="(!this.partnerForm.controls.partnerName.value)|| (!this.partnerForm.controls.configurations.value) || showTypeError || showSizeError"
              (click)="createPartner()">
              <span i18n="@@partners.create-partner.create-partner">Create Partner</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <iposcen-acknowlegement-dialog #acknowModal [titleText]="acknowlegementTitle" [acknowledgementDesc]="acknowlegementDesc"></iposcen-acknowlegement-dialog>
</div>
<!-- Add New Partner Popup ends here -->
<!--Publish New message Pop-up, IIT3-99-->
<div class="container" id="publishNewMsgCon">
  <div class="modal-dialog modal-dialog-centered" *ngIf="showMessagePopup" id="modalDialog">
    <div class="modal-backdrop show" id="modalBackDrop"></div>
    <div class="modal" id="myModal">
      <div class="modal-dialog" id="myModalPublishDialog">
        <div class="modal-content" id="myModalPublishCon">
          <div class="close" data-dismiss="modal" (click)="onCloseMessagePopup()" id="myModalPublishClose">
            <img class="modal-close-icon" alt="close" />
          </div>
          <div class="modal-body" id="myModalPublishBody">
            <div class="heading" id="publishHeading"><span>{{ partnerMessage }}</span></div>
            <form [formGroup]="publishMessageForm">
              <div [ngClass]="{'show':ispreviousmessage,'hide':!ispreviousmessage}">
                <div class="row">
                  <div class="col-12">
                    <div class="new-message-section">
                      <div class="previous-message-section">
                        <div class="custom-datepicker">
                          <input type="radio" name="publishNewMessage" class="form-check-input" id="newMessage"
                            (click)="switchToPreviousMessage()" />
                          <label for="new message"><span>{{ previousMessage }}</span></label>
                        </div>
                        <div class="custom-datepicker">

                          <input type="radio" name="publishNewMessage" class="form-check-input" id="newMessage"
                            (click)="switchToNewMessage()"
                            [disabled]="publishMessageForm?.controls?.clearMessage?.value" [checked]="ispreviousmessage" />
                          <label for="new message"><span>{{ partnerNewMessage }}</span></label>

                        </div>
                      </div>

                      <div *ngIf="isNewWindowOpen">
                        <textarea formControlName="newMessage" class="form-control" maxlength="250" ></textarea>
                        <div class="row ml-1">
                          <div class="form-group">
                            <label for="ExpirationTimestamp"><span class="form-check p-0">{{ messageExpiration }}</span></label>
                            <div class="publish-radio ml-3">
                              <input type="radio" id="never" name="expirationDate"
                                class="form-check-input" [checked]="!isExpiryDatePicker"
                                (click)="selectExpiryDateTimeZone('Never')" />
                              <label for="never"><span i18n="@@create-logo-content.tab-pane.now">Never</span></label>
                            </div>
                            <div class="custom-datepicker ml-3 mt-2">
                              <input type="radio" class="form-check-input" name="expirationDate"
                                id="expiry-date-custom" [checked]="isExpiryDatePicker"
                                (click)="selectExpiryDateTimeZone('custom')" />
                                <label for="expiry-custom" *ngIf="!isExpiryDatePicker"><span i18n="@@create-logo-content.tab-pane.custom">Custom</span></label>
                              <div for="expiry-date-custom" *ngIf="isExpiryDatePicker">
                                <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'expiry')"
                                  (getDateTimeZoneData)="getMessageExpiryDate($event)"
                                  (isTimeZoneSelected)="checkTimeZone($event,'expiry')" [expiryDateInfo]="editexpiryDateInfo">
                                </iposcen-date-time-zone>
                              </div>
                            </div>
                            <div id="neverExpiredDateIncorrect" *ngIf="isExpiredDateIncorrect" class="formfield_err_msg"><span i18n="@@create-logo-content.tab-pane.expiry-less-than-publish-date">Expiration date should not be before publishing date.</span>
                              </div>
                              <div id="neverCustomExpiryDateCorrect" *ngIf="isCustomExpiryDateCorrect || isCustomExpiryTimeZoneSelected" class="formfield_err_msg"><span i18n="@@create-logo-content.tab-pane.expiry-date-and-time-zone">Please select expiration date and time zone.</span> 
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="!isNewWindowOpen">
                  <textarea formControlName="previousMessage" class="form-control" maxlength="250" disabled="true"></textarea>
                  <div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="clearMessage" value="gaming"
                        formControlName="clearMessage"[checked]="publishMessageForm?.controls?.clearMessage?.value" (change)="onClearMessageCheckboxChange($event)"/>
                      <label class="form-check-label" for="clearMessage"><span>{{ clearPreviousMessage }}</span></label>
                        <ng-template #clearPopContent>
                          <span>{{clearMessageTooltip}}</span>
                        </ng-template>
                      <span class="infoIcon" src="assets/images/info_circle_icon.svg" alt="hover for help" 
                      [ngbPopover]="clearPopContent" placement="auto left" triggers="mouseenter:mouseleave" popoverClass="clearTooltip-publish-message">
                        <span class="round-info-icon"></span>
                      </span>
                    </div>
                    <!--Will update with dynamic value in next pr-->
                    <div class="row data-publish ml-1">
                      <div class="col-4 publish-align p-0">
                        <div class="publish-head"><span>{{ publishDateAndTime }}</span></div>
                        <div>{{publishedDateTime | dateFormat: "changeToLocalTimeZone"}}</div>
                      </div>
                      <div class="col-4 publish-align2 p-0">
                        <div class="publish-head">
                          <span>{{ publishedByName }}</span>
                        </div>
                        <div>{{publishedBy}}</div>
                      </div>
                      <div class="col-4 publish-align p-0">
                        <div class="publish-head">
                          <span>{{ expirationDateAndTime }}</span>
                        </div>
                        <div>{{expiredOEMMsgTime | dateFormat: "24hrP"}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div [ngClass]="{'show':!ispreviousmessage,'hide':ispreviousmessage}">
                <div class="row">
                  <div class="col-6 publish-row">
                    <div [ngClass]="ispreviousmessage? 'new-message-section' : 'message-section'">
                      <div class="custom-datepicker"><span>{{ partnerNewMessage }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <textarea formControlName="newMessage" class="form-control" maxlength="250"></textarea>
                <div class="row ml-1">
                  <div class="form-group">
                    <label for="ExpirationTimestamp"><span class="form-check p-0">{{ messageExpiration }}</span></label>
                    <div class="publish-radio ml-3">
                      <input type="radio" id="never" name="expirationDate"
                        class="form-check-input" [checked]="!isExpiryDatePicker"
                        (click)="selectExpiryDateTimeZone('Never')" />
                      <label for="never"><span i18n="@@create-logo-content.tab-pane.now">Never</span></label>
                    </div>
                    <div class="custom-datepicker ml-3 mt-2">
                      <input type="radio" class="form-check-input" name="expirationDate"
                        id="expiry-date-custom" [checked]="isExpiryDatePicker"
                        (click)="selectExpiryDateTimeZone('custom')" />
                        <label for="expiry-custom" *ngIf="!isExpiryDatePicker"><span i18n="@@create-logo-content.tab-pane.custom">Custom</span></label>
                      <div for="expiry-date-custom" *ngIf="isExpiryDatePicker">
                        <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'expiry')"
                          (getDateTimeZoneData)="getMessageExpiryDate($event)"
                          (isTimeZoneSelected)="checkTimeZone($event,'expiry')" [expiryDateInfo]="editexpiryDateInfo">
                        </iposcen-date-time-zone>
                      </div>
                    </div>
                    <div id="neverExpiredDateIncorrect" *ngIf="isExpiredDateIncorrect" class="formfield_err_msg"><span i18n="@@create-logo-content.tab-pane.expiry-less-than-publish-date">Expiration date should not be before publishing date.</span>
                    </div>
                    <div id="neverCustomExpiryDateCorrect" *ngIf="isCustomExpiryDateCorrect || isCustomExpiryTimeZoneSelected" class="formfield_err_msg"><span i18n="@@create-logo-content.tab-pane.expiry-date-and-time-zone">Please select expiration date and time zone.</span> 
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer" id="modalFooter">
            <button type="button" class="btn btn-outline-primary btn-lg" data-dismiss="modal"
              (click)="onCloseMessagePopup()">
              <span i18n="@@partners.cancel.cancel">Cancel</span>
            </button>
            <button type="button" class="btn btn-primary" (click)="onPublishMessageClick()"
              [disabled]="((!publishMessageForm?.controls?.clearMessage?.value && !isNewWindowOpen) && ispreviousmessage) || (!publishMessageForm?.controls?.newMessage?.value?.trim() && ( !ispreviousmessage || (ispreviousmessage && isNewWindowOpen)))">
              <span *ngIf="!publishMessageForm?.controls?.clearMessage?.value && !isNewWindowOpen || !ispreviousmessage">{{ publishNewMessage }}</span>
              <span *ngIf="publishMessageForm?.controls?.clearMessage?.value && !isNewWindowOpen && ispreviousmessage">{{ clearMessageFromOEM }}</span>
              <span *ngIf="!publishMessageForm?.controls?.clearMessage?.value && isNewWindowOpen && ispreviousmessage">{{ pushNewMessage }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
<iposcen-spinner-overlay></iposcen-spinner-overlay>
